<div class="breadcrumb-area">
	<h1>Recetas</h1>
</div>
<div class="card mb-5">
	<div class="card-header">
		<h3>Recetas Disponibles</h3>
	</div>
	<div class="card-body">
		<div class="input-group input-group-sm mb-3">
			<label for="filterRecipe" class="input-group-text">Filtra</label>
			<input type="text" (input)="filter()" [(ngModel)]="filterWord" name="filterRecipe"
				placeholder="Ingresa el código o el nombre de la receta" id="filterRecipe" class="form-control">
		</div>
		<div class="row">
			<div class="col-sm">
				<div class="table table-responsive">
					<table class="table">
						<caption *ngIf="filterWord">Se muestran los resultados para {{filterWord}}</caption>
						<thead>
							<tr>
								<th class="ta">
									Código
								</th>
								<th>
									Nombre
								</th>
								<th class="ta">
									Ingredientes
								</th>
								<th>
									Fecha de Creación
								</th>
								<th class="ta">
									Editar
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let productRecipe of filterProductRecipes">
								<tr>
									<td class="ta">
										{{productRecipe.product.code}}
									</td>
									<td  class="ta">
										{{productRecipe.product.name}}
									</td>
									<td  class="ta">
										{{productRecipe.quantityIngredients}}
									</td>
                                    <td  class="ta">
										{{productRecipe.creationDate}}
									</td>
									<td class="ta">
										<span (click)="showIngredients(productRecipe)" class="cursor-pointer">
											<i class="fa" [ngClass]="showRecipe[productRecipe.product.id]?'fa-chevron-up':'fa-chevron-down'"></i> {{showRecipe[productRecipe.product.id]?'Ocultar ':'Mostrar '}}
											{{productRecipe.listIngredients.length}} Ingredientes {{showRecipe[productRecipe.product.id]?'':'más'}}
										</span>
									</td>
								</tr>
								<tr *ngIf="showRecipe[productRecipe.product.id]!= null && showRecipe[productRecipe.product.id]">
									<td>{{productRecipe.id}}</td>
									<td class="ta" colspan="4">
										<app-edit-recipe 
										[ingredients]="productRecipe.listIngredients" 
										[recipeId]="productRecipe.product.id"
										(saveDataEvent)="receiveDataSave($event)"
										(deleteDataEvent)="receiveDataDelete($event)"
										(addDataEvent)="receiveDataAdd($event)"
										></app-edit-recipe>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
				<span *ngIf="filterProductRecipes.length==0">
					<i class="fa fa-circle-info"></i>
					{{filterWord?'No existen Recetas para el filtro '+filterWord:'Aún no se han ingresado Recetas'}}
				</span>
			</div>
		</div>
	</div>
</div>

